import { render, staticRenderFns } from "./bim1.vue?vue&type=template&id=0447a11e&scoped=true&"
import script from "./bim1.vue?vue&type=script&lang=js&"
export * from "./bim1.vue?vue&type=script&lang=js&"
import style0 from "./bim1.vue?vue&type=style&index=0&id=0447a11e&scoped=true&lang=css&"
import style1 from "./bim1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0447a11e",
  null
  
)

export default component.exports